import "./AbTestStyles.css";
import AbTestDataBox from "./AbTestDataBox";
import { useState } from "react";
import { getNatureOfElement } from "../../helpers";
import CustomInput from "../CustomInput/CustomInput";

const AbTestStep2Text = ({ setActiveTab, selectedTest, setSelectedTest }) => {
  const oldText = selectedTest.element.data;
  const nature = getNatureOfElement(selectedTest.element.tag);
  const [newText, setNewText] = useState("");

  function handleContinue() {
    if (newText) {
      setSelectedTest((prev) => ({
        ...prev,
        data: newText,
      }));
      setActiveTab(3);
    }
  }

  return (
    <div>
      <div className="abtest-info-block mb-50">
        <div> Change the content you want to test.</div>
      </div>
      <div className="d-flex">
        <div className="abtest-step2-left">
          <div className="mb-100">
            <div className="fw-700 fs-18 fc-black mb-20">Element to change</div>
            <div className="mb-10">
              <AbTestDataBox
                type="grey"
                header="Nature of the element"
                content={nature}
              />
            </div>
            <div>
              <AbTestDataBox type="grey" header="Content" content={oldText} />
            </div>
          </div>
        </div>

        <div className="abtest-step2-right">
          <div className="fw-700 fs-18 fc-black">New version</div>
          <div className="mt-82">
            <CustomInput
              minWidth="100%"
              type="text"
              placeholder={"New content"}
              onChange={(e) => setNewText(e.target.value)}
              valueState={newText}
            />
            <div className="w-100 justify-right">
              <button
                onClick={handleContinue}
                disabled={!newText}
                className="btn-primary mt-16"
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AbTestStep2Text;
